var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"submit-button w-button",attrs:{"disabled":_vm.disabled,"type":"submit"},on:{"click":_vm.clickHandler}},[(_vm.loading)?_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')]):_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }